import { get, isString } from 'lodash';

import { isNilOrBlankString } from '@nova/core';

/** Prefer the API message when present; otherwise the caller's fallback. */
export function getApiErrorMessage(error: unknown, fallback: string): string {
  const apiMessage = get(error, 'response.data.message');

  return isString(apiMessage) && !isNilOrBlankString(apiMessage) ? apiMessage : fallback;
}
